module.exports = __webpack_public_path__ + "static/assets/b77bd40e28ea6776c9c2b7f365b16cd8.png";